import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { CompaniesPage } from "@/pages/dashboard/companies/list";

export const Route = createFileRoute("/_main/dashboard/companies/")({
  component: () => (
    <RequirePermission action="companies.read">
      <CompaniesPage />
    </RequirePermission>
  ),
});
